import styled, { css } from 'styled-components';
import { useState } from 'react';

import { GiftCardsFactsWindow } from 'gift-cards/components/GiftCardsFactsWindow';
import { INITIAL_WINDOW_STATE } from 'gift-cards/enums/constants';
import { ClientOnlyPortal } from 'shared/components/ClientOnlyPortal';
import { variableFontRegular } from 'styles/theme/text';
import { t } from 'localization/utils/t';

const TP = 'giftCards.components.GiftCardsFooterLinksMobile';

export const GiftCardsFooterLinksMobile = () => {
  const [window, setWindow] = useState(INITIAL_WINDOW_STATE);

  const handleClick = () => {
    setWindow({ isOpen: true, isPermanent: true });
  };

  const handleClose = () => {
    setWindow(INITIAL_WINDOW_STATE);
  };

  return (
    <GiftCardsFooterLinksMobile.Wrapper>
      <GiftCardsFooterLinksMobile.Link $isOpen={window.isOpen} onClick={handleClick} type="button">
        {t(`${TP}.facts`, 'Facts')}
      </GiftCardsFooterLinksMobile.Link>
      {window.isOpen && (
        <ClientOnlyPortal selector="#main-page-layout">
          <GiftCardsFactsWindow isPermanent={window.isPermanent} handleClose={handleClose} />
        </ClientOnlyPortal>
      )}
    </GiftCardsFooterLinksMobile.Wrapper>
  );
};

GiftCardsFooterLinksMobile.Wrapper = styled.div`
  align-items: flex-start;
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  flex-direction: row;
  flex: 1;
  height: 100%;
  justify-content: flex-end;
`;

GiftCardsFooterLinksMobile.Link = styled.button<{ $isOpen?: boolean }>`
  margin-right: 16px;
  width: fit-content;

  ${variableFontRegular({ size: '11px', height: '14px' })}
  ${({ $isOpen }) =>
    $isOpen &&
    css`
      text-decoration: underline;
    `}

    &:hover {
    text-decoration: underline;
  }
`;
